<span>{{ favouriteCount }}</span>
